// extracted by mini-css-extract-plugin
var _1 = "tjs-story-button__storyBtn tjs-_buttons__btn tjs-_buttons__btn--map";
export { _1 as "storyBtn" }
export default { "storyBtn": _1 }
